import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioSnrs } from './pages'

type TIdToPageMapStylioSnrs = Record<PageIdStylioSnrs, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_SNRS: TIdToPageMapStylioSnrs = {
  [PageIdStylioSnrs.AGE_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/AgeQuestion'),
  },
  [PageIdStylioSnrs.URGE_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs/pages/urge/UrgePage'),
  },
  [PageIdStylioSnrs.HAIR_COLOR_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioSnrs.EYES_COLOR_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioSnrs.JEWELRY_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/JewelryQuestion').then(
        (m) => ({
          default: m.JewelryQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioSnrs.BODY_SHAPE_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioSnrs.STYLIO_TO_HELP_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/StylioToHelp'),
  },
  [PageIdStylioSnrs.TALL_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/TallQuestion'),
  },
  [PageIdStylioSnrs.WEIGHT_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/WeightQuestion'),
  },
  [PageIdStylioSnrs.URGE_2_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioSnrs.SHOPPING_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/ShoppingQuestion').then(
        (m) => ({
          default: m.ShoppingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioSnrs.STYLE_MOST_MATTERS_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioSnrs.FAVORITE_COLORS_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant1Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant1Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant1Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_11_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant2Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant2Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant2Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_12_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant3Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant3Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant3Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_13_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant4Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant4Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant4Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_14_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant5Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant5Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant5Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_15_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant6Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant6Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant6Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_16_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant7Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant7Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant7Snrs'
      ),
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_17_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant8Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant8Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/likeOrDislike/LikeOrDislikeVariant8Snrs'
      ),
  },
  [PageIdStylioSnrs.STYLES_FEEL_LIKE_YOU_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/StylesFeelLikeYou'
      ).then((m) => ({
        default: m.StylesFeelLikeYou,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/StylesFeelLikeYou'),
  },
  [PageIdStylioSnrs.URGE_4_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioSnrs.BRAND_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/BrandQuestion'),
  },
  [PageIdStylioSnrs.FIND_NEW_CLOTHES_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioSnrs.NOTHING_TO_WEAR_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/NothingToWearQuestion'),
  },
  [PageIdStylioSnrs.OLD_CLOTHES_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioSnrs.COMBINE_CLOTHES_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioSnrs.OUTFIT_LOOK_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/OutfitLook').then(
        (m) => ({
          default: m.OutfitLook,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/OutfitLook'),
  },
  [PageIdStylioSnrs.OPTIMIZE_BUDGET_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioSnrs.EVERYDAY_LIFESTYLE_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/questions/EverydayLifestyle'
      ).then((m) => ({
        default: m.EverydayLifestyle,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/EverydayLifestyle'),
  },
  [PageIdStylioSnrs.CLIMAT_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/questions/ClimatQuestion').then(
        (m) => ({
          default: m.ClimatQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/questions/ClimatQuestion'),
  },
  [PageIdStylioSnrs.URGE_3_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioSnrs.PREPARE_FLOW_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioSnrs.EMAIL_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs/pages/email/Email'),
  },
  [PageIdStylioSnrs.EMAIL_CONSENT_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs/pages/email/EmailConsent'),
  },
  [PageIdStylioSnrs.SUBSCRIPTIONS_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioSnrs.CANCEL_OFFER_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioSnrs.SUB_UPSELL_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioSnrs.UPSELL_SNRS]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs/pages/upsell/Upsell'),
  },
  [PageIdStylioSnrs.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioSnrs.DOWNLOAD_SNRS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs/pages/download-app/DownloadDefault'),
  },
}
